import type { CategoryWithChannels } from '@setplex/tria-api'
import type { TvChannelPayment } from '~/features/payment/interfaces'

import { exists } from '~/shared/helpers'

const CustomCategoryName = {
  Banner: 'Banner',
  Featured: 'Featured Live Channels',
  All: 'All',
} as const
type CustomCategoryName =
  (typeof CustomCategoryName)[keyof typeof CustomCategoryName]

export const formatSelectedTvChannel = ({
  selectedChannel,
  categories,
}: {
  selectedChannel: TvChannelPayment
  categories: CategoryWithChannels[] | null
}) => {
  let categoryName = selectedChannel.categoryName ?? ''

  const selectedCategory = categories?.find(
    ({ id }) => selectedChannel.categoryId === id
  )

  const selectedCategoryName = selectedCategory?.name

  if (exists(selectedCategoryName)) {
    categoryName = selectedCategoryName
  }

  if (selectedChannel.featured) {
    categoryName = CustomCategoryName.Featured
  }

  if (selectedChannel.isBanner) {
    categoryName = CustomCategoryName.Banner
  }

  if (selectedChannel.isAll) {
    categoryName = CustomCategoryName.All
  }

  return { ...selectedChannel, categoryName }
}
